// The seven layers — colours, stroke styling, display names, and colour family.
// Lifted verbatim from the R10 §III standalone `LAYERS` const so the chart and
// legend read the same palette the design froze. `family` groups the colour
// legend (amber = dynamic, moss = relational, paper = slow-arc); solid/dashed/
// dotted differentiates lines inside a family.

export const LAYERS = [
  { id: 'L1', key: 'Vitality',   name: 'vitality',        color: '#D48A3C', dash: null,     w: 1.7, glow: true, family: 'dynamic' },
  { id: 'L2', key: 'Security',   name: 'security',        color: '#C7BFAE', dash: null,     w: 1.4, family: 'slow-arc' },
  { id: 'L3', key: 'Growth',     name: 'growth',          color: '#8FA168', dash: null,     w: 1.4, family: 'relational' },
  { id: 'L4', key: 'Authorship', name: 'authorship',      color: '#C7BFAE', dash: '6 4',    w: 1.4, family: 'slow-arc' },
  { id: 'L5', key: 'Wanting',    name: 'wanting',         color: '#A86520', dash: null,     w: 1.4, family: 'dynamic' },
  { id: 'L6', key: 'Yourself',   name: 'being yourself',  color: '#8FA168', dash: '6 4',    w: 1.4, family: 'relational' },
  { id: 'L7', key: 'Lasting',    name: 'wanted to last',  color: '#C7BFAE', dash: '1.5 4',  w: 1.4, family: 'slow-arc' },
];
